//AgConnexion Panel
import './ag-connexion.scss';

class AgConnexion {

  components;
  panel;
  overlay;

  constructor(componentsSelector, panelSelector, overlaySelector) {
    if (document.querySelectorAll(componentsSelector)) {
      this.components = document.querySelectorAll(componentsSelector);
      this.panel = document.querySelector(panelSelector);
      this.overlay = document.querySelector(overlaySelector);
    }
  }

  init() {
    this.components.forEach((component) => {
      component.addEventListener('click', (event) => {
        event.preventDefault();

        if (this.panel.classList.contains('open')) {
          this.closePanel();
        } else {
          this.openPanel();
        }
      });

    });

    // Close panel when clicking on overlay (outside panel).
    if (this.overlay) {
      this.overlay.addEventListener('click', (event) => {
        event.preventDefault();
        this.closePanel();
      });
    }

    this.createSpacingBigMenu();
  }

  openPanel() {
    this.panel.classList.add('open');
    this.overlay.style.display = 'block';
    document.body.classList.add('prevent-scroll');
  }

  closePanel() {
    this.panel.classList.remove('open');
    this.overlay.style.display = 'none';
    document.body.classList.remove('prevent-scroll');
  }

  createSpacingBigMenu() {
    if (document.querySelector('.agriculture-numerique')) {
      document.querySelectorAll('.agriculture-numerique .menu-productions .menu-item > a:not(.menu__agconnexion-lower)').forEach((selector) => {
        let texts = selector.innerText.split(/(\|)/);
        let svg = selector.querySelector('.field--name-field-media-svg');
        selector.innerText = '';
        selector.appendChild(svg);
        texts.forEach((text) => {
          selector.appendChild(document.createTextNode(text.replace(/(\r\n|\n|\r)/gm, "")));
          if (text === '|') {
            let spacing = document.createElement('br');
            spacing.classList.add('special-line-break-desktop--only')
            selector.appendChild(spacing);
          }
        });
      });
    }

  }
}

window.addEventListener('load', () => {
  let agc = new AgConnexion('.ag-connexion-toggle', '.ag-connexion-content', '#ag-connexion-selector-overlay');
  agc.init();
});
